import { Outlet, useParams } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useGroups } from 'modules/reviews/hooks/useGroups'
import { useReview } from 'modules/reviews/hooks/useReview'

export default function ReviewUserRootPage() {
  const { id, user_id } = useParams()
  const { loading, review } = useReview(id)
  const { loading: loadingGroups } = useGroups()
  const userId = Number(user_id)

  return (
    <ResponsivePage.Body
      loading={loading || loadingGroups}
      error={!loading && !review}
      showHeader={false}
    >
      {review && <Outlet context={{ review, userId }} />}
    </ResponsivePage.Body>
  )
}
